import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { Dispatch } from 'redux';

import { requestHandler } from '../../api';
import {
  CreateWriteOffInput,
  GetAvailableDocumentsResponse,
  GetWriteOffsResponse,
} from './types';

export const getWriteOffs = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['writeOffs'],
    queryFn: async (): Promise<GetWriteOffsResponse | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: '/internal/writeOff/getAll',
        dispatch,
      });
      if (response) return response.data;
    },
    retry: 1,
  });

export const getAvailableDocuments = (dispatch: Dispatch) =>
  useQuery({
    queryKey: ['getAvailableDocumentsForWriteOff'],
    queryFn: async (): Promise<GetAvailableDocumentsResponse | undefined> => {
      const response = await requestHandler({
        method: 'get',
        url: '/internal/writeOff/availableDocuments',
        dispatch,
      });
      if (response) return response.data;
    },
    retry: 1,
  });

export const createWriteOff = (dispatch: Dispatch) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['createWriteOff'],
    mutationFn: async (
      data: CreateWriteOffInput,
    ): Promise<{ message: string } | undefined> => {
      const response = await requestHandler({
        method: 'post',
        url: '/internal/writeOff/create',
        dispatch,
        data,
      });
      if (response) return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['writeOffs'] });
    },
  });
};

export const deleteWriteOff = (dispatch: Dispatch) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: ['deleteWriteOff'],
    mutationFn: async (id: number): Promise<void> => {
      await requestHandler({
        method: 'delete',
        url: `/internal/writeOff/delete/${id}`,
        dispatch,
      });
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['writeOffs'] });
    },
  });
};
